"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PageConfig = _interopRequireDefault(require("./setPage/PageConfig.vue"));
var _index = _interopRequireDefault(require("./library/index.vue"));
var _html2canvas = _interopRequireDefault(require("html2canvas"));
var _domToImage = _interopRequireDefault(require("dom-to-image"));
var _validate = require("@/utils/validate");
var _common = require("./components/js/common");
var _index2 = _interopRequireDefault(require("./library/index.js"));
var _draggableEffect = _interopRequireDefault(require("./components/js/draggableEffect.js"));
var _api = require("./components/js/api");
var _systemSetting = require("@/api/systemSetting");
var _utils = require("@/utils");
var _index3 = _interopRequireDefault(require("../../../../components/SkinPreview/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  components: {
    PageConfigVue: _PageConfig.default,
    MyComponent: _index.default,
    SkinPreview: _index3.default
  },
  mixins: [_draggableEffect.default],
  data: function data() {
    return {
      library: _index2.default,
      previewIndex: null,
      settingKey: 1,
      form: {
        componentList: []
      },
      dragstartItem: null,
      libraryIndex: null,
      loading: false,
      loadingText: '保存中...',
      activeIdx: -1
    };
  },
  watch: {
    '$route.query': {
      handler: function handler(newVal) {
        this.form = {
          componentList: []
        };
        if (newVal.id && this.$route.path == '/applet/decorationPage') {
          this.getDetail(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    swapElement: _common.swapElement,
    updateForm: function updateForm(data, index) {
      this.$set(this.form.componentList, index, data);
    },
    addComponent: function addComponent(obj, idx) {
      this.activeIdx = idx;
      // this.previewIndex = null;
      this.form.componentList.push(obj);
      this.previewItemClick(this.form.componentList.length - 1);
    },
    changeSetting: function changeSetting(key) {
      this.settingKey = key;
    },
    deleteComponent: function deleteComponent(index) {
      this.form.componentList.splice(index, 1);
      if (this.form.componentList.length === index && this.previewIndex === index) {
        this.previewIndex = index - 1;
      }
      if (this.form.componentList.length === 0) {
        this.settingKey = 1;
      }
    },
    sortComponent: function sortComponent(e, index, type) {
      e.stopPropagation();
      this.$set(this.form, 'componentList', this.swapElement(this.form.componentList, index, index + type));
      this.previewIndex += type;
    },
    previewItemClick: function previewItemClick(index) {
      this.previewIndex = index;
      this.settingKey = 2;
    },
    updatePageConfig: function updatePageConfig(_ref) {
      var prop = _ref.prop,
        data = _ref.data;
      // debugger
      console.log('form', this.form);
      this.$set(this.form, prop, data);
    },
    close: function close() {
      this.$store.dispatch('tagsView/delView', this.$route);
      this.$router.go(-1);
    },
    // ----预览区拖拽事件--------------------------------------------------------------------
    updatePosition: function updatePosition(start, end) {
      // const current = deepCopy(this.form.componentList[start]);
      // this.form.componentList.splice(start, 1);
      // this.form.componentList.splice(end, 0, current);
    },
    handleDragenter: function handleDragenter(e, index) {
      // this.dragging = index;
    },
    handleDrop: function handleDrop(e, index) {
      // if (index === null || this.dragStartIndex === null) return;
      // this.updatePosition(this.dragStartIndex, index);
      // this.dragstartIndex = null;
      // this.dragging = null;
    },
    // -----组件库区拖拽事件--------------------------------------------------------------
    libraryDragstart: function libraryDragstart(e, index, item) {
      // this.dragstartItem = item;
      // this.libraryIndex = index;
    },
    libraryDragend: function libraryDragend() {
      // this.dragend();
      // this.libraryIndex = null;
    },
    drop: function drop(e) {
      // e.preventDefault();
      // if (!this.dragstartItem) return;
      // if (e.target.dataset.dragbox) {
      //   this.addComponent(this.dragstartItem);
      // } else {
      //   this.form.componentList.splice(this.dragging, 0, this.dragstartItem);
      // }
      // this.dragstartItem = null;
      // this.dragging = null;
    },
    // -----走接口------------------------------------------------------------------------
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(api, params, callback) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return api(params);
            case 1:
              res = _context.v;
              callback(res);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.loading = false;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    handleInfo: function handleInfo() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref2 = obj || {},
        config = _ref2.config,
        _ref2$componentList = _ref2.componentList,
        componentList = _ref2$componentList === void 0 ? [] : _ref2$componentList;
      this.$refs.pageConfigVueRef.initForm(config);
      this.form = _objectSpread({
        componentList: componentList && componentList.length && componentList.map(function (j) {
          return JSON.parse(j.value);
        })
      }, config);
    },
    getDetail: function () {
      var _getDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _this = this;
        var _ref3, id, _ref3$isDraft, isDraft;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref3 = row || {}, id = _ref3.id, _ref3$isDraft = _ref3.isDraft, isDraft = _ref3$isDraft === void 0 ? 0 : _ref3$isDraft;
              this.request(_api.getDetailApi, {
                id: id,
                isDraft: isDraft
              }, function (res) {
                _this.handleInfo(res);
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetail(_x4) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    handleParams: function handleParams() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      function handleFilterGoods() {
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref4 = obj || {},
          showCateId = _ref4.showCateId,
          labelId = _ref4.labelId,
          skuId = _ref4.skuId;
        switch (obj.goodsType) {
          case 1:
            return showCateId && showCateId.length ? showCateId.map(function (j) {
              return j.at(-1);
            }).join(',') : null;
          case 2:
            return labelId ? labelId.join(',') : null;
          case 3:
            return skuId;
          default:
            return '';
        }
      }
      return {
        type: params.status || 1,
        config: _objectSpread(_objectSpread({}, this.$refs.pageConfigVueRef.form), params),
        componentList: this.form.componentList.map(function (j) {
          if (j.showType === 6) {
            j.goodsStr = handleFilterGoods(j);
          }
          return {
            showType: j.showType,
            value: JSON.stringify(j)
          };
        })
      };
    },
    previewH5: function previewH5() {
      this.$refs['SkinPreviewRef'].previewSetting(this.handleParams({}));
    },
    save: (0, _validate.Debounce)(/*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(status) {
        var _this2 = this;
        var targetDom, node, _node$getBoundingClie, width, height, toBlobRes, file, formData, data, uploadRes, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              this.loadingText = '保存快照中...';
              targetDom = this.$refs.iphoneRef || {};
              console.log('targetDom', targetDom);
              (0, _html2canvas.default)(targetDom, {
                useCORS: true,
                //图片跨域，开启跨域配置
                logging: false,
                //日志开关，便于查看html2canvas的内部执行流程
                taintTest: true,
                //是否在渲染前测试图片
                height: targetDom.offsetHeight,
                //注意 下面解决当页面滚动之后生成图片出现白边问题
                width: targetDom.offsetWidth //注意 下面解决当页面滚动之后生成图片出现白边问题
              }).then(function (canvas) {
                var url = canvas.toDataURL('image/jpeg', 0.8); //下载链接
                _this2.loadingText = '提交保存中...';
                _this2.request(_api.saveOrUpdateApi, _this2.handleParams({
                  previewImg: url,
                  status: status
                }), function (res) {
                  _this2.loading = false;
                  _this2.form = {
                    componentList: []
                  };
                  _this2.$refs.pageConfigVueRef.reset();
                  _this2.$message.success('保存成功！');
                  _this2.$router.push({
                    path: '/applet/pageList'
                  });
                });
              }).catch(function (err) {
                _this2.loading = false;
              });
              return _context3.a(2);
            case 2:
              toBlobRes = _context3.v;
              // 加100是为了防止截图不全
              file = new File([toBlobRes], "snapshot.png", {
                type: toBlobRes.type
              });
              formData = new FormData();
              formData.append('multipart', file);
              data = {
                model: 'wechat',
                pid: 8
              };
              _context3.n = 3;
              return (0, _systemSetting.fileImageApi)(formData, data);
            case 3:
              uploadRes = _context3.v;
              if (uploadRes.url) {
                this.loadingText = '提交保存中...';
                this.request(_api.saveOrUpdateApi, this.handleParams({
                  previewImg: uploadRes.url,
                  status: status
                }), function (res) {
                  _this2.loading = false;
                  _this2.form = {
                    componentList: []
                  };
                  _this2.$refs.pageConfigVueRef.reset();
                  _this2.$message.success('保存成功！');
                  _this2.$router.push({
                    path: '/applet/pageList'
                  });
                });
              }
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t2 = _context3.v;
              this.loading = false;
              this.$message({
                type: 'error',
                message: '保存失败！-----> 失败原因：' + JSON.stringify(_t2)
              });
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 4]]);
      }));
      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }())
  }
};